'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/input/style/css.js
// module id = RisF
// module chunks = 0